/**
 * CommonGoods — Inline Product Carousel
 * File: assets/cg-product-carousel.js
 *
 * Cara pakai di isi artikel (HTML mode):
 *   <div class="cg-products" data-collection="airytech" data-limit="4"></div>
 *
 * Atribut opsional:
 *   data-title="Shop The Look"       → judul section (default: "Shop The Look")
 *   data-collection="airytech"       → handle collection Shopify
 *   data-limit="4"                   → jumlah produk (default: 4)
 */

(function () {
  'use strict';

  /**
   * Format harga ke format Rupiah
   * Shopify products.json mengembalikan harga sebagai string seperti "89000.00"
   */
  function formatRupiah(priceStr) {
    var num = Math.round(parseFloat(priceStr));
    return 'Rp\u00a0' + num.toLocaleString('id-ID');
  }

  /**
   * Resize URL gambar Shopify (pakai image_url parameter)
   */
  function resizeShopifyImg(src, size) {
    if (!src) return '';
    // Format Shopify CDN: ...product-name_800x800.jpg
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  /**
   * Render skeleton loading cards
   */
  function renderSkeletons(grid, count) {
    for (var i = 0; i < count; i++) {
      var card = document.createElement('div');
      card.className = 'cg-product-card cg-product-card--skeleton';
      card.innerHTML =
        '<div class="cg-product-card__img-wrap"></div>' +
        '<div class="cg-skel-line"></div>' +
        '<div class="cg-skel-line short"></div>';
      grid.appendChild(card);
    }
  }

  /**
   * Render satu kartu produk
   */
  function renderProductCard(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return '';

    var price = variant.price;
    var comparePrice = variant.compare_at_price;
    var isOnSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);

    var imgSrc = product.images && product.images[0]
      ? resizeShopifyImg(product.images[0].src, '400x400')
      : '';

    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" class="cg-product-card__img" loading="lazy" width="400" height="400">'
      : '';

    var badgeHtml = isOnSale ? '<span class="cg-product-card__badge">Sale</span>' : '';

    var priceHtml = isOnSale
      ? '<span class="cg-product-card__compare">' + formatRupiah(comparePrice) + '</span>' + formatRupiah(price)
      : formatRupiah(price);

    return (
      '<a href="/products/' + product.handle + '" class="cg-product-card">' +
        '<div class="cg-product-card__img-wrap">' +
          imgHtml +
          badgeHtml +
        '</div>' +
        '<div class="cg-product-card__name">' + escapeHtml(product.title) + '</div>' +
        '<div class="cg-product-card__price">' + priceHtml + '</div>' +
      '</a>'
    );
  }

  /**
   * Escape HTML untuk keamanan
   */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * Init satu carousel block
   */
  function initBlock(el) {
    var collection = el.getAttribute('data-collection') || 'frontpage';
    var limit = parseInt(el.getAttribute('data-limit')) || 4;
    var title = el.getAttribute('data-title') || 'Shop The Look';

    // Buat struktur container
    var block = document.createElement('div');
    block.className = 'cg-products-block';

    var header = document.createElement('div');
    header.className = 'cg-products-block__header';
    header.innerHTML =
      '<span class="cg-products-block__title">' + escapeHtml(title) + '</span>' +
      '<a href="/collections/' + collection + '" class="cg-products-block__link">Lihat semua →</a>';

    var grid = document.createElement('div');
    grid.className = 'cg-products-grid';

    block.appendChild(header);
    block.appendChild(grid);

    // Replace elemen asli dengan block kita
    el.parentNode.replaceChild(block, el);

    // Tampilkan skeleton dulu
    renderSkeletons(grid, limit);

    // Fetch produk dari Shopify AJAX API
    fetch('/collections/' + collection + '/products.json?limit=' + limit, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var products = data.products || [];
        // Hapus skeleton
        grid.innerHTML = '';
        if (products.length === 0) {
          block.style.display = 'none';
          return;
        }
        // Render produk
        products.forEach(function (product) {
          grid.insertAdjacentHTML('beforeend', renderProductCard(product));
        });
      })
      .catch(function (err) {
        // Kalau gagal, sembunyikan saja
        console.warn('[CG Carousel] Error loading products:', err);
        block.style.display = 'none';
      });
  }

  /**
   * Main init — cari semua shortcode di halaman
   */
  function init() {
    var elements = document.querySelectorAll('.cg-products[data-collection]');
    elements.forEach(function (el) {
      initBlock(el);
    });
  }

  // Jalankan setelah DOM siap
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
